import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing"; // Import Integrations from the correct module
import { appConfig } from "./AppConfig";

const configureSentry = () => {
    Sentry.init({
        dsn: appConfig.getSentryKey(),
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 0.1, 
    });
}

export default configureSentry;